import React, { lazy } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { Route, LazyRoute } from "seed/helpers";
import StyleColor from "components/util/helpers/StyleColor"
import Onboarding from "components/vmisc/onboarding/Onboarding";
import Presentation from "components/presentation/Presentation";
import { UserUsageProvider } from "components/util/helpers/UserUsage";
import { UserPermissionsProvider } from "./util/helpers/UserPermissions";

const Studio = lazy(() => import("components/studio/Studio"));
const Settings = lazy(() => import("components/vmisc/settings/Settings"));
const Organizations = lazy(() => import("components/vmisc/organizations/Organizations"));
const AuthHandler = lazy(() => import("components/util/schema_form/fields/account_picker/AuthHandler"));
const NotificationsPanel = lazy(() => import("components/vmisc/notifications/NotificationsPanel"));

const HomeView = ({ user, theme }) =>
  <BrowserRouter basename="/app">
    <UserUsageProvider>
      <UserPermissionsProvider>
        <Switch>
          <Route path={["/home", "/settings", "/organizations", "/notifications"]}
            component={() => <StyleColor theme={theme} backgroundHeight="45vh" />} />
          {/* No background by default (studio, token, etc) */}
          <Route path="/" component={() => <StyleColor theme={theme} backgroundHeight="0vh" />} />
        </Switch>

        <div>
          <main id="content" role="main">
            <Switch>
              <Route path="/onboarding" component={Onboarding} />
              <LazyRoute path="/settings/auth" component={AuthHandler} />
              <LazyRoute path="/settings" component={Settings} />
              <LazyRoute path="/notifications" component={NotificationsPanel} />
              <LazyRoute path="/organizations" component={Organizations} />
              <LazyRoute path="/studio/:flowId" component={Studio} />
              <Route path="/" component={Presentation} />
              <Redirect to="/" />
            </Switch>
          </main>
        </div>
      </UserPermissionsProvider>
    </UserUsageProvider>
  </BrowserRouter>;

export default HomeView;